import React from 'react';
import './About.css';

const About = () => {
    return (
        <div className='about'>
            <h1>Md. Arshad</h1>
            <p>I am a Professional Wedding Photographer, have completed more than 500 wedding photoshoot. I have 9 years of experience in Wedding Photoshoot. I have studied Masters in Professional Photoshoot and Photo Editing. My Goals are to provide my customer the best service possible. I respond to my customer queries as soon as possible. I edit the wedding photos within 7 days od shooting and expect to deliver final products within 10 days.</p>
        </div>
    );
};

export default About;